// TODO: Add typing
/* eslint-disable @typescript-eslint/no-explicit-any */

import PropTypes from 'prop-types';
import React, { forwardRef, createElement } from 'react';
const translateDate = '';

const UI = forwardRef(({ components, ...uiProps }, ref) => {
  const context = uiProps.context || {};
  const t = {};

  if (typeof components === 'undefined' || components === null) {
    return null;
  }

  if (
    typeof components === 'string' ||
    typeof components === 'number' ||
    typeof components === 'boolean'
  ) {
    return <>{components}</>;
  }

  if (typeof components === 'object') {
    if ('context' in components) {
      const { context: contextKey } = components;
      if (typeof contextKey === 'string') {
        return context[contextKey];
      }
    } else if ('i18nKey' in components) {
      const translation = t(components);
      return <>{translation}</>;
    } else if ('i18nDate' in components) {
      return <>{translateDate(components, context)}</>;
    }
  }

  const { type, children } = components;
  const props = components.props || {};

  if (typeof type !== 'string') return null;

  if (children && props) {
    props.children = children;
  }

  //   const mappedType = getMappedType(type);
  const mappedType = '';

  return createElement(
    mappedType,
    Object.entries(props).reduce(
      (acc, [key, value]) => {
        if (key === 'children') {
          acc[key] = (typeof value.context === 'string'
            ? Array.isArray(context[value.context])
              ? context[value.context]
              : [context[value.context]]
            : value
          ).map((childrenComponents, index) => {
            if (
              typeof mappedType !== 'string' &&
              mappedType.directDescendants
            ) {
              return childrenComponents;
            }

            return (
              <UI
                key={index}
                context={context}
                components={childrenComponents}
                ref={ref}
              />
            );
          });
        } else if (value && typeof value === 'object') {
          let valueOrValueFromContext = value;
          if (typeof value.context === 'string') {
            valueOrValueFromContext = context[value.context];
          }
          if ('i18nKey' in value) {
            valueOrValueFromContext = t(value);
          }
          if ('i18nDate' in value) {
            valueOrValueFromContext = translateDate(value, context);
          }
          if (
            valueOrValueFromContext &&
            typeof valueOrValueFromContext.event === 'string'
          ) {
            acc[key] = {};
          } else if (
            Array.isArray(valueOrValueFromContext) &&
            valueOrValueFromContext.length > 0 &&
            valueOrValueFromContext.every(
              item => typeof item.props === 'object',
            )
          ) {
            acc[key] = (
              <>
                {valueOrValueFromContext.map((propComponents, index) => (
                  <UI
                    key={`${valueOrValueFromContext}-${index}`}
                    context={context}
                    components={propComponents}
                    ref={ref}
                  />
                ))}
              </>
            );
          } else {
            acc[key] = valueOrValueFromContext;
          }
        } else {
          acc[key] = value;
        }

        return acc;
      },
      { ref },
    ),
  );
});

UI.defaultProps = {
  components: null,
};

UI.propTypes = {
  context: PropTypes.objectOf(PropTypes.any.isRequired).isRequired,
  components: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.string,
      props: PropTypes.objectOf(PropTypes.any.isRequired),
      context: PropTypes.objectOf(PropTypes.any.isRequired),
    }),
  ]),
};

export default UI;
